import {getJson, putJson, postJson, deleteJson} from '@/util/ajaxUtils';

export function getCorp() {
    return getJson('/corps');
}

export function updateCorp(corp) {
    return putJson(`/corps/${corp.id}`, {data: corp});
}

export function addCorp(corp) {
    return postJson('/corps', {data: corp});
}

export function deleteCorp(corpId) {
    return deleteJson(`/corps/${corpId}`);
}
